$(document).on('click', '.js_form-order-btn', orderForm);
$(document).on('click', '.js_form-order-pay-btn', orderPayForm);
$(document).on('click', '.js_form-coupon-btn', couponBtn);
$(document).on('change', '.js_order-type-ticket', orderTypeTicketChange);
$(document).on('change', '.js_select_station_from, .js_select_station_from_return', selectOrderStationFrom);
$(document).on('change', '.js_select_station_to, .js_select_station_to_return', selectOrderStationTo);
$(document).on('change', '.js_select_station-type_to, .js_select_station-type_from, .js_select_station-type_to_return, .js_select_station-type_from_return', selectOrderStationType);
$(document).on('change', '#country-codes, select[name="phone-code"]', SelectCodeCountry);
$(document).on('click', '.js_send-to-email', sendPDFEmail);
$(document).on('click', '.js_submit-email', sendEmail);
$(document).on('click', '.modal span.close', closePopup);
$(document).on('click', '.js_order_info', orderInfo);

$(document).on('ready', readyPage);
$(window).on('pageshow', resetOrderButtonsLoadingState);

function readyPage() {
    maskPhone();
    selectOrderStationTypeReady();
    checkAddressBlock();
    setDocumentMask();
    initDocTypeChangeHandler();
    resetOrderButtonsLoadingState();
}

function resetOrderButtonsLoadingState() {
    $('.js_form-order-btn').each(function () {
        var $btn = $(this);
        $btn.removeClass('is-loading');
        $btn.prop('disabled', false);
    });
}


function getPhoneInputsForCountrySelect($countrySelect) {
    const $wrapper = $countrySelect.closest('.js_phone-country-group');
    if ($wrapper.length) return $wrapper.find('.js_mask-phone');

    const $form = $countrySelect.closest('form');
    return $form.length ? $form.find('.js_mask-phone') : $('.js_mask-phone');
}

function maskPhone() {
    let $countryCodes = $('#country-codes, select[name="phone-code"]');
    if (!$countryCodes.length) {
        return;
    }

    $countryCodes.each(function () {
        let $countrySelect = $(this);
        let $phoneInputs = getPhoneInputsForCountrySelect($countrySelect);

        if (!$phoneInputs.length) return;

        switchCountry($countrySelect.val(), $phoneInputs);
    });
}

function switchCountry(country, $phoneInputs) {
    $phoneInputs = $phoneInputs && $phoneInputs.length ? $phoneInputs : $(".js_mask-phone");
    const phoneMasks = {
        us: "+1 (999) 999-99-99",
        gr: "+30 (999) 999-99-99",
        nl: "+31 (999) 999-999",
        be: "+32 (999) 999-999",
        fr: "+33 (999) 99-99-99",
        es: "+34 (999) 999-999",
        prt: "+351 (999) 999-999",
        ie: "+353 (999) 999-999",
        mt: "+356 (99) 999-999",
        fi: "+358 (999) 999-999",
        bg: "+35\\9 (999) 999-999",
        hu: "+36 (999) 999-999",
        lt: "+370 (999) 99-999",
        lv: "+371 (999) 99-9-99",
        ee: "+372 (99) 99-999",
        md: "+373 (999) 99999",
        by: "+375 (99) 999-99-99",
        ua: "+380 (99) 999-99-99",
        it: "+3\\9 (999) 999-99-99",
        ro: "+40 (999) 999-999",
        ch: "+41 (999) 999-999",
        cz: "+420 (999) 999-999",
        sk: "+421 (999) 999-999",
        au: "+43 (999) 999-99-99",
        gb: "+44 (999) 999-99-99",
        dk: "+45 (999) 99-9-99",
        se: "+46 (999) 999-999",
        no: "+47 (999) 99-9-99",
        pl: "+48 (999) 999-999",
        de: "+4\\9 (999) 999-999-99",
        ru: "+7 (999) 999-99-99",
        tr: "+\\90 (999) 999-99-99",
        ae: "+\\971 (9)9-999-99-99",
        il: "+\\972 (99) 999-99-99",
        tj: "+\\9\\92 (999) 999-999",
        tm: "+\\9\\93 (999) 999-999",
        az: "+\\9\\94 (999) 999-999",
        ge: "+\\9\\95 (999) 999-999",
        kg: "+\\9\\96 (999) 999-999",
        uz: "+\\9\\98 (999) 999-999",
    };

    if (phoneMasks[country]) {
        $phoneInputs.inputmask(phoneMasks[country]);
    }
}

function SelectCodeCountry() {
    let $countrySelect = $(this);
    let $phoneInputs = getPhoneInputsForCountrySelect($countrySelect);

    switchCountry($countrySelect.val(), $phoneInputs);
}

maskPhone();

function setDocumentMask() {
    const $docType = $('#doc_type');
    const $docNumber = $('#doc_number');
    
    if ($docNumber.length > 0) {
        let docTypeValue = null;
        
        if ($docType.length > 0) {
            docTypeValue = $docType.val();
        } else {
            docTypeValue = $docNumber.attr('data-doc-type');
        }
        
        if (docTypeValue === '0') {
            $docNumber.inputmask("9999 999999", {
                placeholder: "",
                showMaskOnHover: false,
                showMaskOnFocus: false,
                clearIncomplete: false,
                autoUnmask: true,
            });
        } else {
            if ($docNumber.inputmask) {
                $docNumber.inputmask('remove');
            }
        }
    }
}

function initDocTypeChangeHandler() {
    $(document).on('change', '#doc_type', function() {
        const $docNumber = $('#doc_number');
        
        if ($docNumber.inputmask) {
            $docNumber.inputmask('remove');
        }
        
        $docNumber.val('');
        
        setDocumentMask();
    });
}

function setMasksIfPassport(e = null) {
    const selects = document.querySelectorAll('select');
    const inputs = document.querySelectorAll('input');

    $selects = [];
    $inputs = [];

    selects.forEach(select => {
        if (!select.name.includes('doc_type') && !select.id.includes('doc_type')) {
            return;
        }
        $selects.push($(select));
    });

    inputs.forEach(input => {
        if (!input.name.includes('doc_number') && !input.id.includes('doc_number')) {
            return;
        }
        $inputs.push($(input));
    });

    for (let i in $selects) {
        $select = $selects[i];

        if ($inputs.length && $inputs[i] !== undefined) {
            $input = $inputs[i];

            if ($select.val() === "0") {
                if ($input.hasClass('passport_mask')) continue;

                let setValue = ''
                if (!$input.hasClass('value_is_set')) {
                    setValue = $input.val();
                    $input.addClass('value_is_set');
                }

                $input.addClass('passport_mask');

                $input.inputmask("9999 999999", {
                    placeholder: "",
                    showMaskOnHover: false,
                    showMaskOnFocus: false,
                    clearIncomplete: false,
                    autoUnmask: true,
                });

                $input.val(setValue);
                $input.attr('last_type', '0');
            } else {
                if ($input.hasClass('passport_mask')) {
                    $input.removeClass('passport_mask');
                    $input.inputmask('remove');
                }

                if ($input.attr('last_type') && $input.attr('last_type') != $select.val()) {
                    $input.val('');
                }
                $input.attr('last_type', $select.val());
            }
        }
    }
}

window.setMasksIfPassport = setMasksIfPassport;

function selectOrderStationFrom() {
    let data = {},
        url = $(this).data('url'),
        returnTxt = $(this).data('return') ? '_return' : '';

    data['station_from_id'] = $(this).val();
    data['station_to_id'] = $("[name='station_to_id" + returnTxt + "']").val();
    data['destination'] = 'from';
    data['return_ticket'] = $(this).data('return');

    let is_return = data['return_ticket'] ? '.return-tickets' : '.direct-tickets';

    visibleAddressBlock($(this).find(':selected').data('is_default'), $($(this).data('address-block')))

    $.get(url, data).success(function (data) {
        if (data.result == 'error') {
            toastr.error(data.message);
            $("[name='station_from_id" + returnTxt + "']").val(data.station_from_id);
            $("[name='station_to_id" + returnTxt + "']").val(data.station_to_id);
        } else {
            toastr.success(data.message);
            $('.js_time_from' + returnTxt).html(data.DateFrom);
            $('.js_time_to' + returnTxt).html(data.DateTo);
            $('.js_order-prices' + is_return).html(data.htmlPrices);
        }
    });
}

function selectOrderStationTo() {
    let data = {},
        url = $(this).data('url'),
        returnTxt = $(this).data('return') ? '_return' : '';

    data['station_from_id'] = $("[name='station_from_id" + returnTxt + "']").val();
    data['station_to_id'] = $(this).val();
    data['destination'] = 'to';
    data['return_ticket'] = $(this).data('return');

    let is_return = data['return_ticket'] ? '.return-tickets' : '.direct-tickets';

    visibleAddressBlock($(this).find(':selected').data('is_default'), $($(this).data('address-block')))

    $.get(url, data).success(function (data) {
        if (data.result == 'error') {
            toastr.error(data.message);
            $("[name='station_from_id" + returnTxt + "']").val(data.station_from_id);
            $("[name='station_to_id" + returnTxt + "']").val(data.station_to_id);
        } else {
            toastr.success(data.message);
            $('.js_time_from' + returnTxt).html(data.DateFrom);
            $('.js_time_to' + returnTxt).html(data.DateTo);
            $('.js_order-prices' + is_return).html(data.htmlPrices);
        }
    });
}

function visibleAddressBlock(defaultParam, addressBlock) {
    if (addressBlock.length) {
        if (defaultParam) {
            if (!addressBlock.children('input').length) {
                addressBlock.prepend('<input style="width: 90%; height: 33px; box-sizing: border-box; line-height: 32px; padding-left: 5px;" autocomplete="address-line" type="text" id="' + addressBlock.data('id') + '" class="input" name="' + addressBlock.data('name') + '" value="' + addressBlock.data('value') + '" placeholder="' + addressBlock.data('placeholder') + '">').show();
                addressBlock.siblings('[name*="is_new_stations"]').val(1);
            } else {
                addressBlock.children('input').val(addressBlock.data('value')).prop('placeholder', addressBlock.data('placeholder'));
            }
        } else {
            addressBlock.hide().children('input').remove();
            addressBlock.siblings('[name*="is_new_stations"]').val(0);
        }
    }
}

function checkAddressBlock() {
    let fields = [
        $('[name="station_from_id"]'),
        $('[name="station_to_id"]'),
        $('[name="station_from_id_return"]'),
        $('[name="station_to_id_return"]')
    ];

    $.each(fields, function () {
        let self = $(this);

        if (self.length) {
            visibleAddressBlock(self.find(':selected').data('is_default'), $(self.data('address-block')))
        }
    })
}

function selectOrderStationTypeReady() {
    let filters = [
        $('.js_select_station-type_to:checked'),
        $('.js_select_station-type_from:checked'),
        $('.js_select_station-type_to_return:checked'),
        $('.js_select_station-type_from_return:checked')
    ];
    
    $.each(filters, function () {
        let self = $(this);

        if (self.length) {
            let select = $('.' + self.attr('class').replace('-type', ''));

            selectOrderStationOptgroup(select);
        }
    })
}
function selectOrderStationType() {
    let self = $(this),
        select = $('.' + self.attr('class').replace('-type', '')),
        disabled = parseInt(self.val()) - 1;

    select.find('option').each(function () {
        let self = $(this);

        self.data('is_default') ? self.prop('hidden', !disabled) : self.prop('hidden', disabled);
    });

    selectOrderStationOptgroup(select);

    select.find('option:not([hidden])').eq(0).prop('selected', 1);
    select.trigger('change');
}
function selectOrderStationOptgroup(select) {
    select.find('optgroup').each(function () {
        let self = $(this);

        (self.find('option[hidden]').length == self.find('option').length) ? self.prop('hidden', true) : self.removeAttr('hidden');
    })
}

function couponBtn() {
    let url = $(this).data('url');
    let code = $('.js_form-coupon-code').val();
    let $prices = $('.js_order-prices');
    $.get(`${url}?unique_code=${code}&document_type=receipt`, (response) => {
        if (response.result == 'success') {
            toastr.success(response.message);
        } else {
            toastr.error(response.message);
        }
        $prices.html(response.view);
    })
}

function orderForm() {
    const $docType = $('#doc_type');
    const $docNumber = $('#doc_number');
   if ($docNumber.length > 0) {
        let docTypeValue = null;
        
        if ($docType.length > 0) {
            docTypeValue = $docType.val();
        } else {
            docTypeValue = $docNumber.attr('data-doc-type');
        }
        
        if (docTypeValue === '0' && $docNumber.val().replace(/[\s_]/g, '').length != 10) {
            toastr.error('Номер документа имеет неверный формат (нужно 10 цифр)');
            $('html, body').animate({ scrollTop: 0 }, 800);
            return;
        }
    }
    if (checkChildValidation()) {
        let $form = $('.js_form-order');
        var btn = $(this);

        if (btn.prop('disabled') || btn.hasClass('is-loading')) {
            return;
        }

        btn.addClass('is-loading');
        btn.prop('disabled', true);

        $form.one('form-ajax-success form-ajax-error', function (event, response) {
            const hasRedirect = response && response.result == 'success' && (response.redirect || $form.hasClass('js_form-step-order'));

            if (!hasRedirect) {
                btn.removeClass('is-loading');
                btn.prop('disabled', false);
            }
        });

        $form.submit();
    }
}

function orderPayForm() {
    $('<input>').attr({ type: 'hidden', id: 'is_pay', name: 'is_pay', value: 1 }).appendTo('form');
    orderForm();
}

function orderTypeTicketChange() {
    let self = $(this),
        className = self.attr('class');
    getOrderTickets(self, 'direct', className);
    if (self.data('has_return')) {
        getOrderTickets('return', className);
    }
  
}
function getOrderTickets(el, direction, className) {
    let placeId=$(el).data("placeid");
    let tariffs = $("#type_ticket_"+placeId+"_child").data("tariffs")?$("#type_ticket_"+placeId+"_child").data("tariffs"):0;
    
    
    let tickets = $('.js_order-prices.' + direction + '-tickets'),
        data = {
            dir: direction
        };

    $('.' + className + ':checked').each(function () {
        let self = $(this),
            name = self.attr('name'),
            value = self.val()

        data[name] = value;
    });    
    
    if(!tariffs.length) {
        $.get('/order/type-ticket', data, function (response) {
            if (response.result == 'success') {
                toastr.success(response.message);
            } else {
                toastr.error(response.message);
            }
            tickets.html(response.view);
            $('#total-ticket-' + direction).text(parseFloat(response.total).toFixed(2));
    
            setTicketType('child');
            setTicketType('pensioner');
            setTicketType('svo');
        });
    } else if($(el).val() == "default" ) {
        $("#child_extra_fields_"+placeId).attr("style","display: none;}");
        let priceDefault = $("#child_extra_fields_"+placeId).data("price");
        let total= parseFloat($(".total-price").html().replace(/[\s,]/g, ''));
        let priceCustom = parseFloat($(el).parent().parent().parent().parent().find(".label.label-warning").html().split("RUB")[0]);
        let newTotal = total + priceDefault - priceCustom;
        $(el).parent().parent().parent().parent().find(".label.label-warning").html(priceDefault+" RUB");
        $(".total-price").html(newTotal.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }));
        $("#child_extra_fields_"+placeId).find("input").val(" ");
        $("#child_extra_fields_"+placeId).find("select").val(" ");

        setTicketType('child');
        setTicketType('pensioner');
    } else {
        $("#child_extra_fields_"+placeId).attr("style","display: flex;justify-content: center;align-items: anchor-center;}");
        setTicketType('child');
        setTicketType('pensioner');
    }
   
}
window.setDiscountPrice = function(el, type) {
    var changedValue = $(el).val();
    let tariffs = $(el).parent().data("tariffs");
    
    if (type=="age") {
     var age = changedValue;
    } else {
        
        const today = new Date();
        const birthDate = new Date(changedValue);
        
        var age = today.getFullYear() - birthDate.getFullYear();
        const monthDiff = today.getMonth() - birthDate.getMonth();

        if (monthDiff < 0 || (monthDiff === 0 && today.getDate() < birthDate.getDate())) {
          age--;
        }
    }    
    var rate =  tariffs.filter(rate => age >= rate.min_year && age <= rate.max_year)[0];
    let priceDefault = $(el).parent().data("price");
    if (rate) {
        let discountType = rate.cost_type,
        discountValue = rate.cost,
        priceCustom = discountType ? (priceDefault * (100 - discountValue) / 100) : (priceDefault - discountValue);
        $(el).parent().parent().parent().find(".label.label-warning").html(priceCustom+" RUB");
        let total= $(".total-price").data("price");
        let newTotal = total - priceDefault + priceCustom;
        $(".total-price").html(newTotal);
    } else {
        $(el).parent().parent().parent().find(".label.label-warning").html(priceDefault+" RUB");
        $(".total-price").html($(".total-price").data("price").toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).replace(/,/g, ' '));
    }     
    
}
function setTicketType(keyword) {
    let Ids = [];

    $('input[name="count_' + keyword + '"]').val($('.js_order-type-ticket[value="' + keyword + '"]:checked').length);
    $('.js_order-type-ticket[value="' + keyword + '"]').each((index, element) => {
        if (element.checked) {
            Ids.push(index);
        }
    });
    $('input[name="' + keyword + 'Ids"]').val(Ids.toString());
}

function closePopup() {
    let $popup = $('#js_email-popup');
    $popup.html('');
}

function sendPDFEmail() {
    let id = $(this).attr('data-order-id');
    let url = '/profile/generate-pdf-to-email/' + id;
    let $popup = $('#js_email-popup');
    let $this = this;

    $("#js_ticket-active").attr("data-ticket-id", id);

    let button_message_waiting = 'Обрабатывается...';
    let button_message_again = 'Отправить еще раз?';

    $($this).html(button_message_waiting);
    $.get(url, (response) => {
        if (response.result == 'success') {
            toastr.success(response.message);
        } else {
            toastr.error(response.message);
            $popup.html(response.view);
            $('#popup1').show();
        }
        $($this).html(button_message_again);
    })
}

function sendEmail() {

    let url = '/profile/update/email';
    let email = $('#settings-input').val();

    $.post(url, {
        email: email
    }, function (data) {
        if (data.result == 'error') {
            toastr.error(data.message);
        } else {
            toastr.success('Данные успешно обновлены');
            closePopup();
            $(".js_send-to-email").trigger("click")
        }
    });
}

function orderInfo() {
    let url = '/api/v1/client/order/info';
    let slug = $('#order-slug').val();

    $.post(url, {
        slug: slug
    }, function (data) {
        if (data.result == 'error') {
            toastr.error(data.message);
        } else {
            $('#info-date').text(data.stationFromTime);
            $('#info-route').text(data.routeName);
            $('#info-driver').text(data.driverName);
            $('#info-driver-phone').text(data.driverNumber);
            $('#info-car').text(data.busName);
            let status = data.status;
            let pay = data.typePay;
            if (status === 'active') {
                $('#info-status').text('Активный заказ');
                switch (pay) {
                    case 'waiting':
                        $('#info-pay').text('Ждет оплаты');
                        break;
                    case 'cash-payment':
                        $('#info-pay').text('Оплата наличными');
                        break;
                    case 'success':
                        $('#info-pay').text('Оплачено');
                        break;
                }
            }
            if (status === 'disable') {
                $('#info-status').text('Заказ отменен');
            }
        }
    });
}
function checkChildValidation() {
    var valid = true,
     showBirthError = false,
     showAgeError = false;
    document.querySelectorAll('[name^="type_ticket"]').forEach(function (input) {
        if (input.checked && input.value === 'child') {
            const placeId = input.dataset.placeid;
            const birthInput = document.getElementById(`dob_${placeId}`);
            const ageSelect = document.getElementById(`age_${placeId}`);

            if (birthInput && birthInput.offsetParent !== null) {
                if (!birthInput.value) {
                    birthInput.classList.add('is-invalid');
                    birthInput.focus();
                    valid = false;
                    showBirthError = true;

                } else {
                    birthInput.classList.remove('is-invalid');
                }
            } else if (ageSelect && ageSelect.offsetParent !== null) {
                if (!ageSelect.value) {
                    ageSelect.classList.add('is-invalid');
                    ageSelect.focus();
                    valid = false;
                    showAgeError = true;

                } else {
                    ageSelect.classList.remove('is-invalid');
                }
            }
        }
    });

    if (!valid) {
        const modal = document.getElementById('child-error-modal');
        if (modal) {
            modal.style.display = 'block';
            if (showBirthError) {
                modal.textContent = 'Пожалуйста, укажите дату рождения для всех детских билетов.';
            } else if (showAgeError) {
                modal.textContent = 'Пожалуйста, укажите возраст для всех детских билетов.';
            } 
            setTimeout(() => {
                modal.style.display = 'none';
            }, 10000);
        }

        e.preventDefault();
        e.stopPropagation();
        return fasle;
    }
    else {
        const alertBox = document.getElementById('child-error-alert');
        if (alertBox) {
            alertBox.classList.add('d-none');
            alertBox.style.display = 'none';
        }
        return true;
    }
}
